var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',[_vm._t("default")],2):(_vm.error)?_c('div',[_c('error')],1):_c('div',{staticClass:"loading"},[_c('spinner',{class:_vm.page ? "pt-5" : "",attrs:{"white":_vm.page}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }